import { isIconKey, TIconKey } from "@/ui/components/primitives/Icon";
import { TAlertAsset } from "./Alert.config";

export const isAlertAssetIconKey = (asset: TAlertAsset): asset is TIconKey => (
  isIconKey(asset)
);
